import $ from 'jquery';

const url = location.href;
const via = location.host;
const title = document.title;
const image = document.querySelector('meta[property="og:image"]')?.content;

const shareUrls = {
  wechat: '',
  weibo: `https://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${image}`,
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&via=${via}`,
  linkedin: `http://www.linkedin.com/shareArticle?url=${url}`,
};
const shareIcon = {
  wechat: `
    <svg width="1em" height="1em">
      <use xlink:href="#svg--WeChat"></use>
    </svg>
  `,
  weibo: `
    <svg width="1em" height="1em">
      <use xlink:href="#svg--Weibo"></use>
    </svg>
  `,
  facebook: `
    <svg width="1em" height="1em">
      <use xlink:href="#svg--Facebook"></use>
    </svg>
  `,
  linkedin: `
    <svg width="1em" height="1em">
      <use xlink:href="#svg--Linkedin"></use>
    </svg>
  `,
};

function getSnsBtn(name) {
  const $btn = $(`
    <button class="share-icon">
      ${shareIcon[name]}
    </button>
  `);
  if (name == 'wechat') {
    console.log(url);
    let _code = new QRCode(document.querySelector('.share-block__qrcode'), {
      text: url,
      width: 300,
      height: 300,
    });
    setTimeout(() => {
      new bootstrap.Tooltip($btn[0], {
        html: true,
        title: _code._el.innerHTML,
        customClass: 'tooltip--qrcode tooltip--white',
      });
    }, 100);
  } else {
    $btn.on('click', function (e) {
      e.preventDefault();
      const { width, height } = window.screen;
      let [w, h] = [600, 550];
      let [l, t] = [(width - w) / 2, (height - h) / 2];
      shareUrls[name] &&
        open(
          shareUrls[name],
          '_blank',
          `width=${w}, height=${h}, innerHeight=${h}, top=100, left=${l}`,
        );
    });
  }
  return $btn;
}

class ShareBlock {
  constructor($block, title = 'Share') {
    this.$block = $block;
    this.title = title;
    this.init();
  }
  init() {
    if (window._shareBlockInit) return;
    window._shareBlockInit = true;
    this._insertDOM();
  }
  _insertDOM() {
    const { $block, title } = this;
    const template = `
      <div class="share-block d-flex align-items-center">
        <div class="t-body2 t-bold text-body me-4">${title}</div>
        <div class="share-block__sns d-flex flex-wrap gap-2"></div>
        <div class="share-block__qrcode d-none">
      </div>
    `;
    const $el = (this.$el = $(template));
    $block.append($el);
    const $sns = $el.find('.share-block__sns');
    for (const key in shareUrls) {
      $sns.append(getSnsBtn(key));
    }
  }
  show() {
    this.$el.modal('show');
  }
}

function shareInit($el) {
  if ($el.length === 0) return;
  const { title } = $el.data('share');
  new ShareBlock($el, title);
}

shareInit($('[data-share]').eq(0));
